var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tc-video-player-box",
      style: { transform: `scale(${_vm.autoScale ? _vm.screenScale : 1})` },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.isMatchDayEnding &&
                _vm.streamUrl &&
                !_vm.isWebRTCStream &&
                !_vm.videoPlayerReady,
              expression:
                "!isMatchDayEnding && streamUrl && !isWebRTCStream && !videoPlayerReady",
            },
          ],
          staticClass: "video-wrapper",
        },
        [_c("VideoLoadingOverlay", { attrs: { variant: "placeholder" } })],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.isMatchDayEnding &&
                _vm.streamUrl &&
                !_vm.isWebRTCStream &&
                _vm.videoPlayerReady,
              expression:
                "!isMatchDayEnding && streamUrl && !isWebRTCStream && videoPlayerReady",
            },
          ],
          ref: "videoPlayerContainer",
          staticClass: "video-wrapper",
        },
        [
          _c("div", {
            ref: "vePlayerCanvasContainer",
            staticClass: "ve-player-canvas-source",
            attrs: { id: _vm.veCanvasContainerId },
          }),
          _c("canvas", {
            ref: "videoCanvas",
            staticClass: "video-canvas",
            class: {
              isLarger: _vm.screenScale > 1,
              "ios-canvas": _vm.isIOSDevice,
              "android-canvas": _vm.isAndroidDevice,
            },
            staticStyle: { display: "none" },
            on: {
              click: _vm.handleCanvasClick,
              "&touchstart": function ($event) {
                return _vm.handleTouchStart.apply(null, arguments)
              },
              touchmove: _vm.handleTouchMove,
            },
          }),
          !_vm.isReinitializing
            ? _c(
                "div",
                {
                  staticClass: "video-controls",
                  class: {
                    "controls-visible": _vm.showControls || _vm.isPaused,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleControlsClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "volume-control",
                      on: {
                        mouseenter: function ($event) {
                          _vm.showVolumeSlider = true
                        },
                        mouseleave: function ($event) {
                          _vm.showVolumeSlider = false
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showVolumeSlider && !_vm.isIOSDevice,
                              expression: "showVolumeSlider && !isIOSDevice",
                            },
                          ],
                          staticClass: "volume-slider-container",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.volume,
                                expression: "volume",
                              },
                            ],
                            staticClass: "volume-slider",
                            attrs: {
                              type: "range",
                              min: "0",
                              max: "100",
                              title: `Volume: ${_vm.volume}%`,
                            },
                            domProps: { value: _vm.volume },
                            on: {
                              input: _vm.updateVolume,
                              __r: function ($event) {
                                _vm.volume = $event.target.value
                              },
                            },
                          }),
                          _c("span", { staticClass: "volume-value" }, [
                            _vm._v(_vm._s(_vm.volume) + "%"),
                          ]),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "control-btn volume-btn",
                          attrs: { title: _vm.volumeTitle },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleVolumeClick.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _vm.volume === 0
                            ? _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z",
                                    },
                                  }),
                                ]
                              )
                            : _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z",
                                    },
                                  }),
                                ]
                              ),
                        ]
                      ),
                    ]
                  ),
                  _vm.isPaused
                    ? _c(
                        "button",
                        {
                          staticClass: "control-btn play-btn",
                          attrs: { title: "Play" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handlePlayClick.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                              },
                            },
                            [_c("path", { attrs: { d: "M8 5v14l11-7z" } })]
                          ),
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "control-btn pause-btn",
                          attrs: { title: "Pause" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handlePauseClick.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                              },
                            },
                            [
                              _c("path", {
                                attrs: { d: "M6 4h4v16H6V4zm8 0h4v16h-4V4z" },
                              }),
                            ]
                          ),
                        ]
                      ),
                ]
              )
            : _vm._e(),
          _vm.isPaused && !_vm.isReinitializing
            ? _c("div", {
                staticClass: "video-paused-overlay",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handlePlayClick.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
          _vm._t("overlay"),
        ],
        2
      ),
      _vm.isWebRTCStream
        ? _c("div", { staticClass: "no-active-arena" }, [
            _c("img", {
              staticClass: "logo",
              attrs: { src: require("@/assets/images/alert.webp") },
            }),
            _c("div", { staticClass: "text" }, [
              _vm._v(" " + _vm._s(_vm.$t("Stream not available")) + " "),
            ]),
          ])
        : _vm._e(),
      !_vm.streamUrl
        ? _c(
            "div",
            { staticClass: "no-active-arena" },
            [
              !_vm.streamError
                ? _c("img", {
                    staticClass: "logo",
                    attrs: { src: require("@/assets/images/alert.webp") },
                  })
                : _c("img", {
                    staticClass: "logo-out-of-balance",
                    attrs: { src: require("@/assets/images/out-of-money.png") },
                  }),
              _vm.streamError
                ? [
                    _c("div", { staticClass: "text my-3" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Stream locked")) + " "),
                    ]),
                    _c("div", { staticClass: "text" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.convertStreamErrorMessage(_vm.streamError)
                          ) +
                          " "
                      ),
                    ]),
                  ]
                : [
                    _c("div", { staticClass: "text" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("No fight at the moment")) + " "
                      ),
                    ]),
                    _c("div", { staticClass: "text" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("Please come back again")) + " "
                      ),
                    ]),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm.isMatchDayEnding
        ? _c("div", { staticClass: "no-active-arena match-day-ending" }, [
            _c("img", {
              staticClass: "logo",
              attrs: { src: require("@/assets/images/alert.webp") },
            }),
            _c("div", { staticClass: "text" }, [
              _vm._v(" " + _vm._s(_vm.$t("This arena has ended")) + " "),
            ]),
            _c("div", { staticClass: "text" }, [
              _vm._v(" " + _vm._s(_vm.$t("Thank you for your support")) + " "),
            ]),
          ])
        : _vm._e(),
      !_vm.embedded
        ? _c(
            "div",
            {
              class: [
                "video-banner-wrapper",
                { "is-mobile": _vm.isMobile, reverse: _vm.isReverse },
              ],
            },
            [
              _c("div", { staticClass: "odds-wrapper" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("Banker")))]),
                _vm.autoScale && _vm.screenScale > 1
                  ? _c("span", { staticClass: "ml-16 odds" }, [
                      _vm._v(_vm._s(_vm.bankerOdds)),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "odds-wrapper" }, [
                _vm.autoScale && _vm.screenScale > 1
                  ? _c("span", { staticClass: "mr-16 odds" }, [
                      _vm._v(_vm._s(_vm.playerOdds)),
                    ])
                  : _vm._e(),
                _c("span", [_vm._v(_vm._s(_vm.$t("Player")))]),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }